import React from 'react';
import { isSameDay } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { urnToId } from '../../../../play-core/utils/urn-helper';
import { TvLogo } from '../../components/ChannelLogo/TvLogo';
import { ProgramEntry } from '../../components/Program/ProgramEntry/ProgramEntry';
import { List, ProgramDate, StyledProgram } from '../../components/Program/ProgramEntry/ProgramEntry.styles';
import { useVideoConfig } from '../../config/VideoAppContext';
import { useHydrated } from '../../hooks/use-hydrated';
import { dateOrWeekdayFormat } from '../../utils/date-formatter';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ProgramList = ({
  show,
  onSelect
}) => {
  const {
    t
  } = useTranslation();
  const {
    businessUnit
  } = useVideoConfig();
  const isHydrated = useHydrated();
  const onProgramEntrySelect = program => {
    if (program.channelUrn && program.channelTitle) {
      onSelect({
        program,
        // the channel is not available in this context, as a workaround the channel is derived from the program
        channel: {
          imageUrl: TvLogo(program.channelTitle),
          title: program.channelTitle,
          id: urnToId(program.channelUrn),
          urn: program.channelUrn,
          businessUnit,
          type: 'srg',
          transmission: 'TV'
        }
      });
    }
  };
  return /*#__PURE__*/_jsx(List, {
    children: show.programList.map((program, index, self) => /*#__PURE__*/_jsxs(StyledProgram, {
      children: [isHydrated && (index === 0 || !isSameDay(new Date(program.startTime), new Date(self[index - 1].startTime))) && /*#__PURE__*/_jsx(ProgramDate, {
        children: dateOrWeekdayFormat(program.startTime, t, 6)
      }), /*#__PURE__*/_jsx(ProgramEntry, {
        program: program,
        entryTitle: program.subtitle,
        entrySubtitle: program.title,
        onSelect: () => onProgramEntrySelect(program),
        analyticsPageId: "showBroadcasts"
      })]
    }, program.startTime))
  });
};